import { Button } from '@massilia/ui'
import { Link } from '@tanstack/react-router'
import { FilterX, Plane, RotateCcw } from 'lucide-react'

interface FilteredEmptyCardProps {
  onReset: () => void
}

export function FilteredEmptyCard({ onReset }: FilteredEmptyCardProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-gray-200 bg-white px-8 py-12 shadow-sm">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-amber-50">
        <FilterX className="h-10 w-10 text-amber-500" />
      </div>

      <h2 className="mb-2 text-xl font-semibold text-gray-900">
        Aucun vol ne correspond à vos filtres
      </h2>

      <p className="mb-8 max-w-md text-center text-gray-600">
        Essayez d&apos;assouplir ou de réinitialiser vos filtres pour voir davantage d&apos;offres.
      </p>

      <div className="flex flex-wrap justify-center gap-3">
        <Button
          className="border-sky-200 text-sky-700 hover:bg-sky-50"
          onClick={onReset}
          variant="outline"
        >
          <RotateCcw className="mr-2 size-4" />
          Réinitialiser les filtres
        </Button>
        <Link to="/recherche">
          <Button className="bg-brand-600 hover:bg-brand-700">
            <Plane className="mr-2 size-4" />
            Nouvelle recherche
          </Button>
        </Link>
      </div>
    </div>
  )
}
